/**
 * @typedef {'Local' | 'Regional' | 'International'} StudentType
 *
 * @typedef {'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday'} DayOfWeek
 *
 * @typedef {Object} Student
 * @property {string} id
 * @property {string} name
 * @property {string} instrument
 * @property {StudentType} type
 * @property {DayOfWeek[]} days
 * @property {Record<DayOfWeek, string>} schedule  Map of day -> "HH:mm"
 * @property {string} createdAt  ISO
 *
 * @typedef {'Present' | 'Absent' | 'Excused' | 'Double Session'} AttendanceStatus
 *
 * @typedef {Object} AttendanceRecord
 * @property {string} id
 * @property {string} studentId
 * @property {string} studentName
 * @property {string} date  YYYY-MM-DD
 * @property {AttendanceStatus} status
 * @property {string} remark
 * @property {string} createdAt  ISO
 * @property {string} updatedAt  ISO
 */

export const DAYS_OF_WEEK = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
];

export const ATTENDANCE_STATUSES = [
    "Present",
    "Absent",
    "Excused",
    "Double Session",
];

export const INSTRUMENTS = [
    "Piano",
    "Violin",
    "Guitar",
    "Drums",
    "Cello",
];
